import { useEffect } from 'react';

const BASE_URL = 'https://www.ticketdesk.app';

/**
 * Sets page title, meta description, and canonical URL.
 * Call in any page component to override index.html defaults.
 */
export function useSEO({ title, description, path }) {
  useEffect(() => {
    document.title = title;

    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = description;

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = `${BASE_URL}${path}`;

    // Update OG tags
    const ogTags = { 'og:title': title, 'og:description': description, 'og:url': `${BASE_URL}${path}` };
    for (const [property, content] of Object.entries(ogTags)) {
      let tag = document.querySelector(`meta[property="${property}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.content = content;
    }

    // Update Twitter tags
    const twitterTags = { 'twitter:title': title, 'twitter:description': description };
    for (const [name, content] of Object.entries(twitterTags)) {
      let tag = document.querySelector(`meta[name="${name}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.name = name;
        document.head.appendChild(tag);
      }
      tag.content = content;
    }
  }, [title, description, path]);
}
